import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useEffect, useState } from "react";

// Define the context type
type MapLayersContextType = {
  selectLayerInMap: (value: string) => void;
  loadLayerInMap: string;
  set1Order: string[];
  setIsInitialLoad: (value: boolean) => void;
  isInitialLoad: boolean;
  setIsWavesLoad: (value: boolean) => void;
  isWavesLoad: boolean;
  setIsAirPressureLoad: (value: boolean) => void;
  isAirPressureLoad: boolean;
  setIsRainLoad: (value: boolean) => void;
  isRainLoad: boolean;
  setIsTemperatureLoad: (value: boolean) => void;
  isTemperatureLoad: boolean;
  setIsWindLoad: (value: boolean) => void;
  isWindLoad: boolean;
  setIsRainProbabilityLoad: (value: boolean) => void;
  isRainProbabilityLoad: boolean;
};

const MapLayersContext = createContext<MapLayersContextType | undefined>(
  undefined
);

export const MapLayersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loadLayerInMap, setLoadLayerInMap] = useState<string>("");
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(false);
  const [isWavesLoad, setIsWavesLoad] = useState<boolean>(false);
  const [isAirPressureLoad, setIsAirPressureLoad] = useState<boolean>(false);
  const [isRainLoad, setIsRainLoad] = useState<boolean>(false);
  const [isTemperatureLoad, setIsTemperatureLoad] = useState<boolean>(false);
  const [isWindLoad, setIsWindLoad] = useState<boolean>(false);
  const [isRainProbabilityLoad, setIsRainProbabilityLoad] = useState<boolean>(false);
  const [set1Order, setSet1Order] = useState(["wind", "temperature", "airPressure", "rain"]);


  const selectLayerInMap = (selectLayer: string) => {
    setLoadLayerInMap(selectLayer);
    setSet1Order(prevOrder => {
      if (prevOrder.includes(selectLayer)) {
        return [
          selectLayer,
          ...prevOrder.filter(layer => layer !== selectLayer)
        ];
      }
      else {
        return [selectLayer, ...prevOrder];
      }
    });

  };

  useEffect(() => { }, [loadLayerInMap]);
  useEffect(() => { }, [set1Order]);
  useEffect(() => { }, [isInitialLoad]);

  return (
    <MapLayersContext.Provider
      value={{
        selectLayerInMap,
        loadLayerInMap,
        set1Order,
        setIsInitialLoad,
        isInitialLoad,
        setIsWavesLoad,
        isWavesLoad,
        setIsAirPressureLoad,
        isAirPressureLoad,
        setIsRainLoad,
        isRainLoad,
        setIsTemperatureLoad,
        isTemperatureLoad,
        setIsWindLoad,
        isWindLoad,
        setIsRainProbabilityLoad,
        isRainProbabilityLoad
      }}
    >
      {children}
    </MapLayersContext.Provider>
  );
};

export const useMapLayersContext = () => {
  const context = useContext(MapLayersContext);
  if (!context) {
    throw new Error("useLayerContext must be used within an MapLayerProvider");
  }
  return context;
};